import React, { Component, Suspense } from "react";
import _ from "lodash";
import Loader from "../../../Global/Loader";
import axios from "axios";
import { Services } from "../Services";
import { Button } from "reactstrap";

import { Icon } from "semantic-ui-react";
import { connect } from 'react-redux';
import { Tab } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import TemplateForms from "../template";
import ContainerWrapper from "../../../template/Layout/ContentWrapper";
import SumaryDetail from "./components/general";
import Events from "./components/Events";
import Document from "./components/Documents";
import { FilterForRole } from "../../../Global/Permission/filter";
import { ShowForRole } from "../../../Global/Permission";
import { moduleActions } from "../../../Global/Permission/constants";
import queryString from "query-string";
import { withNamespaces } from 'react-i18next';
import { openNotification } from "../../Components/Notification";
import "./styles/styles.scss";
const Comments = React.lazy(() => import("../../Components/Comments"));
const AllComments = React.lazy(() =>
  import("../../Components/Comments/AllComment")
);

class createUsers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMobil: false,

      clientesSelect: this.props.clients
        ? JSON.stringify(this.props.clients)
        : '[0]',
      scrollLine: true,
      tabActive: 0,
      rolId: this.props._rolId,
      userId: this.props._user,
      AllcommentsData: [
        {
          id: 1,
          title: this.props.t("request"),
          data: [
            {
              expanded: false,
              id: "TP-SEA-2022-0025",
              message: [],
            },
            {
              expanded: false,
              id: "TP-SEA-2022-234",
              message: [
                // {
                //   Color: 1,
                //   Comment: "tester plan de transporte ",
                //   CommentId: 59,
                //   CreationDate: "31-08-2022 10:20:20 AM",
                //   Deleted: "0",
                //   DeletedDate: null,
                //   Important: "0",
                //   Module: "Shipment",
                //   ModuleId: 3,
                //   RolId: 1,
                //   Role: "Administrador",
                //   RowId: 336,
                //   User: "Info Info",
                //   UserId: 1,
                // },
              ],
            },
          ],
        },
        {
          id: 2,
          title: this.props.t("transport_plan"),
          data: [
            {
              expanded: false,
              id: "EP/COA/AI/S0025",
              message: [
                // {
                //   Color: 1,
                //   Comment: "tester plan de transporte ",
                //   CommentId: 59,
                //   CreationDate: "31-08-2022 10:20:20 AM",
                //   Deleted: "0",
                //   DeletedDate: null,
                //   Important: "0",
                //   Module: "Shipment",
                //   ModuleId: 3,
                //   RolId: 1,
                //   Role: "Administrador",
                //   RowId: 336,
                //   User: "Info Info",
                //   UserId: 1,
                // }
              ],
            },
          ],
        },
      ],
      TemplateForms,
      createFormsData: [],
      isEdit: false,
      createForms: [],
      generalInfo: "",
      idOrdenServicio: this.props.match ? this.props.match.params.id : -1,
      info: {},
      allSteps: [],
      newStepsAereoM: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 15,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      newStepsTerrestre: [
        {
          value: "",
          label: this.props.t("created"),
          id: 1,
          completed: false,
          order: 1,
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("cargo_ready"),
          value: "",
          id: 5,
          completed: false,
          order: 2,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("planned"),
          value: "",
          id: 6,
          completed: false,
          order: 3,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("pick_up"),
          value: "",
          id: 8,
          completed: false,
          order: 4,
          middle: false,
          idStep: "",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },

        {
          label: this.props.t("booking"),
          value: "",
          id: 9,
          completed: false,
          order: 5,
          idStep: "step5",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("departure"),
          value: "",
          id: 12,
          completed: false,
          order: 6,
          idStep: "step6",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("arrival"),
          value: "",
          id: 16,
          completed: false,
          order: 7,
          idStep: "step7",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
        {
          label: this.props.t("delivery"),
          value: "",
          id: 21,
          completed: false,
          order: 8,
          idStep: "step8",
          middleStep: "",
          classValue: "subTitleCard",
          classTittle: "statusStepTittle",
        },
      ],
      infoEmbarque: {},
      info: {},
      loadingInfo: true,
      isEditing: false,
      tablaClientes: "",
      commentsData: [],
      users: [],
      catalogsData: [
        {
          ComTypeId: 1,
          ModuleId: 1,
          ComType: "Supplier Follow Up",
          value: 1,
          label: "Supplier Follow Up",
        },
        {
          ComTypeId: 2,
          ModuleId: 1,
          ComType: "Order Quality",
          value: 2,
          label: "Order Quality",
        },
        {
          ComTypeId: 3,
          ModuleId: 1,
          ComType: "Order Quantities",
          value: 3,
          label: "Order Quantities",
        },
        {
          ComTypeId: 10,
          ModuleId: 1,
          ComType: "Other",
          value: 10,
          label: "Other",
        },
      ],
    };
  }

  componentDidMount = async () => {
    let details = navigator.userAgent;
    let regexp = /android|iphone|kindle|ipad/i;
    let isMobileDevice = regexp.test(details);

    this.setState({
      isMobil: isMobileDevice
    })

    const isNotify = queryString.parse(this.props.location.search);
    let notifyActiveComment = false;

    if (isNotify.nofify) {
      notifyActiveComment = true;
    }

    this.getOrdenServicio(notifyActiveComment);
    this.getCommets(false);
  };

  getCommets = (noscroll, messageSucces) => {
    const { idOrdenServicio } = this.state;
    let moduleId = 2;
    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    // let idContainer = 1816;
    axios
      .get(
        `${Services.ORDEN_SERV.path}orderComents/get-comment?rowid=${idOrdenServicio}&moduleid=${moduleId}&general=true&zona=${timezone}&lang=${this.props.lng}`
      )
      .then((response) => {
        let comentario = response.data.Comment;
        let AllcommentsData = response.data.CommentGeneral;
        this.setState(
          { commentsData: comentario, AllcommentsData, scrollLine: noscroll },
          () => {
            if (messageSucces) {
              openNotification('success', messageSucces);
            }
          }
        );
      })
      .catch((error) => {
        console.log(error);
      });
  };

  componentWillReceiveProps = (nextProps) => {
    const isNotify = queryString.parse(nextProps.location.search);
    let notifyActiveComment = false;

    const newProp = nextProps.match.params.id
      ? nextProps.match.params.id
      : this.props.match.params.id;

    this.setState(
      {
        newSelected: [],
        selectcheck: false,
        Form: nextProps.form,
        reset: true,
      },
      () => {
        if (isNotify.nofify) {
          notifyActiveComment = true;
          this.setState(
            {
              idOrdenServicio: newProp,
              loadingInfo: true,
            },
            () => {
              this.getOrdenServicio(notifyActiveComment);
              this.getCommets(true);
            }
          );
        }

        // this.getRoles();
        // this.getUser();
      }
    );
  };
  getOrdenServicio = async (notifyActiveComment) => {
    let { info, tempInfo, idOrdenServicio, infoEmbarque, userId } = this.state;
    axios
      .get(
        `${Services.ORDEN_SERV.path}orden/orderInfo/${idOrdenServicio}?user=${userId}&lang=${this.props.lng}`,
        {
        }
      )
      .then((response) => {
        info = response.data.data;
        let users = response.data.Users;
        tempInfo = _.cloneDeep(response.data.data);
        infoEmbarque = response.data.dataEmbarque;
        info.CheckDeliveryAddress = info.CheckDeliveryAddress == "1";
        info.CheckPickupAddress = info.CheckPickupAddress == "1";
        this.setState(
          {
            tabActive: notifyActiveComment ? 2 : 0,
            info,
            tempInfo,
            infoEmbarque,
            users,
          },
          () => {
            this.getEvents();
          }
        );
      })
      .catch((error) => {
        console.warn(error);
      });
  };

  actualiza = () => {
    let { isEditing } = this.state;
    this.setState(
      {
        isEditing: !isEditing,
        loadingInfo: true,
        info: {},
        tempInfo: {},
        infoEmbarque: {},
      },
      () => {
        this.getOrdenServicio();
      }
    );
  };
  editar = () => {
    let { isEditing } = this.state;
    this.setState({ isEditing: !isEditing });
  };
  showLoad = () => {
    this.setState({ loadingInfo: true });
  };
  finishLoad = () => {
    this.setState({ loadingInfo: false });
  };

  cleanSteps = (transportMode) => {
    const { newStepsAereoM, newStepsTerrestre } = this.state;
    let steps = transportMode === 3 ? newStepsTerrestre : newStepsAereoM;
    steps.map((e) => {
      e.value = "";
      e.completed = false;
      return e;
    });
    return steps;
  };

  getEvents = () => {
    const { idOrdenServicio, info } = this.state;
    axios
      .get(`${Services.ORDEN_SERV.path}orden/orderevents/${idOrdenServicio}?lang=${this.props.lng}`)
      .then((response) => {
        let update = false;
        for (let index = response.data.steps.length; index >= 0; index--) {
          const element = response.data.steps[index];
          if (element && element.completed) update = true;
          if (update) element.completed = true;
        }
        let dataEvents = response.data.data;
        var findNext = false;
        let dateActual = new Date();
        //Road 3
        let newSteps = this.cleanSteps(info.TransportMode);
        newSteps.map((f) => {
          dataEvents.map((e) => {
            if (e.EventDescriptionId === f.id) {
              findNext = true;
              f.value = e.EventDate;
              if (e.InTimeLine === "1") {
                let parts = e.EventDate.split("-");
                // Crear un objeto de fecha con el año, mes (restar 1 porque en JavaScript los meses van de 0 a 11) y día
                let eventDate = new Date(parts[2], parts[1] - 1, parts[0]);
                // Comparar solo año, mes y día de ambas fechas
                let dateActualWithoutTime = new Date(dateActual.getFullYear(), dateActual.getMonth(), dateActual.getDate());
                let eventDateWithoutTime = new Date(eventDate.getFullYear(), eventDate.getMonth(), eventDate.getDate());
                if (dateActualWithoutTime >= eventDateWithoutTime) {
                  f.completed = true;
                } else {
                  f.completed = false;
                }
              }
            } else {
              findNext = false;
            }
            return e;
          });
          return f;
        });
        newSteps.sort(function (a, b) {
          return b.order - a.order;
        });
        let findTrue = false;
        newSteps.map((e) => {
          if (e.completed) {
            findTrue = true;
          }
          if (findTrue) {
            e.completed = true;
          }
          return e;
        });
        newSteps.sort(function (a, b) {
          return a.order - b.order;
        });
        this.setState({
          steps: newSteps,
          allSteps: dataEvents,
          loadingInfo: false,
        });
      })
      .catch((error) => { });
  };

  editar = () => {
    let { isEditing } = this.state;
    this.setState({ isEditing: !isEditing });
  };

  cancelar = () => {
    let { isEditing, tempInfo } = this.state;
    this.setState({
      isEditing: !isEditing,
      info: _.cloneDeep(tempInfo),
    });
  };

  tabChange = (evt, data) => {
    if (data.activeIndex > 0) {
      this.setState({ loadingInfo: false, isEditing: false });
    }
  };

  newMessage = async (data) => {
    let { idOrdenServicio, userId } = this.state;
    data.Rowid = idOrdenServicio;
    data.UserId = userId;
    data.ModuleId = 2;

    if (data.Mentions.length > 0) {
      let uniq = [...new Set(data.Mentions)];
      data.Mentions = uniq;
    }

    axios
      .post(`${Services.ORDEN_SERV.path}orderComents/add-comment`, data)
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_saved"));
      })
      .catch((error) => {
        openNotification('success', 'Error al mandar el comentario');
      });
  };

  deleteMessage = async (idDelete, closeModal) => {
    axios
      .delete(
        `${Services.ORDEN_SERV.path}orderComents/delete-comment/${idDelete}`
      )
      .then((response) => {
        this.getCommets(false, this.props.t("comment_successfully_deleted"));
        closeModal()
      })
      .catch((error) => {
        console.log(error);
      });
  };

  render() {
    let {
      tabActive,
      loadingInfo,
      isEditing,
      commentsData,
      users,
      rolId,
      userId,
      AllcommentsData,
      isMobil
    } = this.state;

    let logoUrl =
      this.state.ModoTransporte === "Air"
        ? "https://magiclog.blob.core.windows.net/europartnerspic/Icono-aereo.svg"
        : this.state.ModoTransporte === "Road"
          ? "https://magiclog.blob.core.windows.net/europartnerspic/Icono_maritimo.svg"
          : "https://magiclog.blob.core.windows.net/europartnerspic/Icono_terrestre.svg";

    return loadingInfo ? (
      <Loader />
    ) : (
      <ContainerWrapper>
        <div className="content-heading">
          <span className="icon-po-visibility icon-header" />
          {this.props.t("request")}
          <div className="euro-return-tittle">
            <Icon.Group size="large">
              <Icon
                name="angle left"
                className="_btnBack"
                size="big"
                onClick={() => this.props.history.push("/po-visibility")}
              />
            </Icon.Group>
            <span className="label-back" onClick={() => this.props.history.push("/po-visibility")}>
              {this.props.t("back")}
            </span>
          </div>
        </div>

        <Tab
          menu={{ secondary: true, pointing: true, className: 'custom-tab-menu' }}
          onTabChange={(event, data) =>
            this.setState({ tabActive: data.activeIndex }, () => this.tabChange)
          }
          activeIndex={tabActive}
          panes={[
            {
              menuItem: this.props.t("summary"),
              render: () => (
                <div className="row">
                  <div className="col-6"></div>
                  {isEditing || this.state.info.StatusId == "13" || this.state.info.StatusId == "35" ? (
                    false
                  ) : (
                    <div className="col-6" style={{ marginTop: isMobil ? '' : "-50px" }}>
                      <ShowForRole
                        rol={this.props._rolId}
                        moduleAction={moduleActions.PEDIDO_EDITAR}
                      >
                        <div className="col-xs-12 col-lg-12 col-sm-12 col-md-12">
                          <FilterForRole
                            rol={this.props._rolId}
                            userId={this.props._user}
                            moduleAction={moduleActions.PEDIDO_EDITAR}
                            userCreatedId={this.state.info.UserCreateId}
                          >
                            <Button
                              color="primary"
                              className="float-right custom-width-btn"
                              onClick={() => this.editar()}
                            >
                              {this.props.t("edit")}
                            </Button>
                          </FilterForRole>
                        </div>
                      </ShowForRole>
                    </div>
                  )
                  }

                  <Suspense fallback={<div>Loading...</div>}>
                    <SumaryDetail
                      steps={this.state.steps}
                      userid={this.props._user}
                      isEditing={this.state.isEditing}
                      cancelar={this.cancelar}
                      actualiza={this.actualiza}
                      infoEmbarque={this.state.infoEmbarque}
                      info={this.state.info}
                      isMobil={isMobil}
                    />
                  </Suspense>
                </div >
              ),
            },
            {
              menuItem: this.props.t("events"),
              render: () => (
                <div className="row">
                  <Suspense fallback={<div>Loading...</div>}>
                    <ContainerWrapper>
                      <Events
                        cliente={this.state.cliente}
                        NIT={this.state.NIT}
                        Grupo={this.state.Grupo}
                        logoUrl={logoUrl}
                        DoEmbarque={this.state.DoEmbarque}
                        HBL_HAWB={this.state.HBL_HAWB}
                        Estatus={this.state.Estatus}
                        allSteps={this.state.allSteps}
                        steps={this.state.steps}
                      />{" "}
                    </ContainerWrapper>
                  </Suspense>
                </div>
              ),
            },
            {
              menuItem: this.props.t("comments"),
              render: () => (
                // <div>
                <Suspense fallback={<div>Loading...</div>}>
                  <ContainerWrapper>
                    <div class="row">
                      <div class="col-xs-12 col-md-6 col-lg-6">
                        <legend className="legendEuroBold">
                          {this.state.info ? this.state.info.RefCustomer : ""}
                        </legend>
                        <Comments
                          rolId={rolId}
                          userId={userId}
                          data={commentsData}
                          catalogs={users}
                          funtionNewMessage={this.newMessage}
                          funtionDeleteMessage={this.deleteMessage}
                        />
                      </div>
                      <div class="col-xs-12 col-md-6 col-lg-6">
                        <legend className="legendEuroBold">
                          {this.props.t("related_comments")}
                        </legend>

                        <AllComments data={AllcommentsData} />
                      </div>
                    </div>
                  </ContainerWrapper>
                </Suspense>

                // </div>
              ),
            },
            {
              menuItem: this.props.t("documents"),
              render: () => (
                <Suspense fallback={<div>Loading...</div>}>
                  <ContainerWrapper>
                    <Document
                      _rolId={this.props._rolId}
                      data={this.state.info}
                      id={this.state.info.ServiceOrderId}
                      _user={this.props._user}
                      isMobil={isMobil}
                    ></Document>{" "}
                  </ContainerWrapper>{" "}
                </Suspense>
              ),
            },
          ]}
        />
      </ContainerWrapper >
    );
  }
}

const mapStateToProps = state => ({
  clients: state.header.clients
});
const mapDispatchToProps = () => ({});
export default withNamespaces()(connect(mapStateToProps, mapDispatchToProps)(withRouter(createUsers)));
